module.exports = __webpack_public_path__ + "img/spu.ef273916.svg";